import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export const AlphaSection = ({ ...section }) => {
  return (
    <Row className="align-items-center my-5">
      <Col lg="6" className="mb-4">
        <div>
          {section.title && <h2 className="text-primary">{section.title}</h2>}
          {section.description && <p>{section.description}</p>}
          <ul>
            {section.points.map((point, index) => {
              if (typeof point === "object") {
                return (
                  <li key={index}>
                    {point.title}
                    {point.subpoints.length > 0 && (
                      <ul>
                        {point.subpoints.map((subpoint, index) => {
                          return <li key={index}>{subpoint}</li>;
                        })}
                      </ul>
                    )}
                  </li>
                );
              } else {
                return <li key={index}>{point}</li>;
              }
            })}
          </ul>
        </div>
      </Col>
      <Col lg="6" className="mb-4">
        <div className="text-center">
          <img
            src={section.imgURL}
            alt="Chart Img"
            width="100%"
            height="auto"
            className="img-fluid obj-fit-cover obj-position-center mw-500"
          />
        </div>
      </Col>
    </Row>
  );
};
